<template>
  <div>
    <h1>Settings Page</h1>
  </div>
</template>

<script>
export default {
  name: "Settings"
};
</script>

<style></style>
